import { Link } from 'react-router-dom';

export default function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-gray-700">
      <p className="text-5xl font-bold text-gray-300">403</p>
      <p className="text-lg font-medium">You don't have permission to view this page</p>
      <Link to="/" className="text-sm text-blue-600 underline hover:text-blue-800">
        Back to dashboard
      </Link>
    </div>
  );
}
